import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AppVersion } from "@ionic-native/app-version";
import { Platform } from "ionic-angular";
import { InAppBrowser } from "@ionic-native/in-app-browser";

@Component({
  selector: 'page-contact',
  templateUrl: 'contact.html'
})
export class ContactPage {

  version = 'UNKNOWN';

  constructor(
      public navCtrl: NavController,
      public appVersion: AppVersion,
      public platform: Platform,
      public iab: InAppBrowser
  ) {
    if(this.platform.is('cordova')){
      this.appVersion.getVersionNumber().then((value) => {
        this.version = value;
      });
    }
  }

  openHomepage(){
    this.iab.create('https://www.maintenanz.com/', '_system');
  }

}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts